import {EXPAND_MODE_EXPANDED} from '../components/List/ExpandAllButton.js'
import {getNounsFromValue, tokenizeOptions} from '../tokenizeOptions.js'
import {
  API_PRODUCT_ACTIVE,
  API_PRODUCT_LOW_INVENTORY_AOH,
  API_PRODUCT_LOW_INVENTORY_POH,
  API_PRODUCT_KIT,
  API_PRODUCT_KIT_COMPONENT,
  API_PRODUCT_MANUFACTURED,
  API_PRODUCT_MANUFACTURING_COMPONENT,
  API_PRODUCT_DROPSHIP,
  API_PRODUCT_NEEDS_SYNC,
  API_PRODUCT_TO_BE_SHIPPED,
  API_PRODUCT_OVERSOLD,
  API_PRODUCT_REORDERED,
  API_PRODUCT_INVENTORY_SYNC_SUSPENDED,
  PRODUCT_BOOLEAN_FILTER_OPTIONS,
} from './Products.js'

export const STOCKTAKE_INITIATED_DISPLAY = 'Initiated'
export const STOCKTAKE_STARTED_DISPLAY = 'Started'
export const STOCKTAKE_COMPLETED_DISPLAY = 'Finished'
export const STOCKTAKE_CANCELLED_DISPLAY = 'Cancelled'

export const STOCKTAKE_BADGES = {
  [STOCKTAKE_INITIATED_DISPLAY]: 'I',
  [STOCKTAKE_STARTED_DISPLAY]: 'S',
  [STOCKTAKE_COMPLETED_DISPLAY]: 'F',
  [STOCKTAKE_CANCELLED_DISPLAY]: 'C',
}

export const DEFAULT_EXPAND_MODE = EXPAND_MODE_EXPANDED
export const DEFAULT_SORT = '-updated_date'
export const DEFAULT_PER_PAGE = 10

export const STOCKTAKE_SORT_OPTIONS = [
  {value: 'reference_id', display: 'Stocktake Session ID (A→Z)'},
  {value: '-reference_id', display: 'Stocktake Session ID (Z→A)'},
  {value: 'warehouse_name', display: 'Warehouse Name (A→Z)'},
  {value: '-warehouse_name', display: 'Warehouse Name (Z→A)'},
  {value: '-created_date', display: 'Date Created (Newest)'},
  {value: 'created_date', display: 'Date Created (Oldest)'},
  {value: '-updated_date', display: 'Date Updated (Newest)'},
  {value: 'updated_date', display: 'Date Updated (Oldest)'},
  {value: '-started_date', display: 'Date Started (Newest)'},
  {value: 'started_date', display: 'Date Started (Oldest)'},
  {value: '-completed_date', display: 'Date Finished (Newest)'},
  {value: 'completed_date', display: 'Date Finished (Oldest)'},
  {value: '-cancelled_date', display: 'Date Cancelled (Newest)'},
  {value: 'cancelled_date', display: 'Date Cancelled (Oldest)'},
]

export const IS_STARTED_FILTER = 'started'
export const IS_COMPLETED_FILTER = 'completed'
export const IS_CANCELLED_FILTER = 'cancelled'
export const STOCKTAKE_STATUS = 'STOCKTAKE_STATUS'

export const STOCKTAKE_TROOLEAN_FILTER_OPTIONS = [
  {
    display: 'Started',
    reverseDisplay: 'Not Started',
    value: IS_STARTED_FILTER,
    otherNouns: 'initiated started',
  },
  {
    display: 'Finished',
    reverseDisplay: 'Not Finished',
    value: IS_COMPLETED_FILTER,
    otherNouns: 'completed done',
  },
  {
    display: 'Cancelled',
    reverseDisplay: 'Not Cancelled',
    value: IS_CANCELLED_FILTER,
    otherNouns: 'closed',
  },
].map((option) => ({
  ...option,
  entity: option,
  type: STOCKTAKE_STATUS,
  nouns: [
    ...getNounsFromValue(
      `${option.display} ${option.reverseDisplay} ${option.otherNouns}`,
    ),
  ],
}))

export const STOCKTAKE_TROOLEAN_FILTERS =
  STOCKTAKE_TROOLEAN_FILTER_OPTIONS.reduce((prev, {value}) => {
    prev.push(value)
    return prev
  }, [])

export const STOCKTAKE_TROOLEAN_FILTER_OPTION_TOKENS = tokenizeOptions(
  STOCKTAKE_TROOLEAN_FILTER_OPTIONS,
)

export const STOCKTAKE_LINE_TOTAL = 'total'
export const STOCKTAKE_LINE_COUNTED = 'counted'
export const STOCKTAKE_LINE_INVENTORIED = 'inventoried'
export const STOCKTAKE_LINE_RECONCILED = 'reconciled'

export const STOCKTAKE_SKU_STATUS = [
  {value: STOCKTAKE_LINE_TOTAL, display: 'Total'},
  {value: STOCKTAKE_LINE_COUNTED, display: 'Counted'},
  {value: STOCKTAKE_LINE_INVENTORIED, display: 'Inventoried'},
  {value: STOCKTAKE_LINE_RECONCILED, display: 'Reconciled'},
]

export const STOCKTAKE_SKU_STATUS_BY_VALUE = STOCKTAKE_SKU_STATUS.reduce(
  (prev, option) => {
    prev[option.value] = option

    return prev
  },
  {},
)

export const STOCKTAKE_URI_COMPONENT = 'stocktake'

export const STOCKTAKE_LINE_SORT_OPTIONS = [
  {value: 'name', display: 'Product (A→Z)'},
  {value: '-name', display: 'Product (Z→A)'},
  {value: 'sku', display: 'SKU (A→Z)'},
  {value: '-sku', display: 'SKU (Z→A)'},
  {value: 'location_in_warehouse', display: 'Location in Warehouse (A→Z)'},
  {value: '-location_in_warehouse', display: 'Location in Warehouse (Z→A)'},
  {value: '-total_available', display: 'Available Quantity (Highest)'},
  {value: 'total_available', display: 'Available Quantity (Lowest)'},
  {value: '-total_on_hand', display: 'On Hand Quantity (Highest)'},
  {value: 'total_on_hand', display: 'On Hand Quantity (Lowest)'},
  {value: '-created_date', display: 'Date Line Added (Newest)'},
  {value: 'created_date', display: 'Date Line Added (Oldest)'},
  {value: '-updated_date', display: 'Date Line Updated (Newest)'},
  {value: 'updated_date', display: 'Date Line Updated (Oldest)'},
  {value: '-inventory_date', display: 'Date Inventoried (Newest)'},
  {value: 'inventory_date', display: 'Date Inventoried (Oldest)'},
  {value: '-last_count_date', display: 'Date Counted (Newest)'},
  {value: 'last_count_date', display: 'Date Counted (Oldest)'},
  {value: '-reconciled_date', display: 'Date Reconciled (Newest)'},
  {value: 'reconciled_date', display: 'Date Reconciled (Oldest)'},
]

export const DEFAULT_LINE_SORT = '-created_date'

export const IS_LINE_STARTED_FILTER = 'started'
export const IS_LINE_COUNTED_FILTER = 'counted'
export const IS_LINE_RECONCILED_FILTER = 'reconciled'

export const STOCKTAKE_PRODUCT_STATUS = 'STOCKTAKE_PRODUCT_STATUS'

export const STOCKTAKE_LINE_TROOLEAN_FILTER_OPTIONS = [
  {
    display: 'Started',
    reverseDisplay: 'Not Started',
    value: IS_LINE_STARTED_FILTER,
    otherNouns: 'initiated',
  },
  {
    display: 'Counted',
    reverseDisplay: 'Not Counted',
    value: IS_LINE_COUNTED_FILTER,
    otherNouns: 'accounted',
  },
  {
    display: 'Reconciled',
    reverseDisplay: 'Not Reconciled',
    value: IS_LINE_RECONCILED_FILTER,
    otherNouns: 'completed done',
  },
  ...[
    API_PRODUCT_ACTIVE,
    API_PRODUCT_LOW_INVENTORY_AOH,
    API_PRODUCT_LOW_INVENTORY_POH,
    API_PRODUCT_KIT,
    API_PRODUCT_KIT_COMPONENT,
    API_PRODUCT_MANUFACTURED,
    API_PRODUCT_MANUFACTURING_COMPONENT,
    API_PRODUCT_DROPSHIP,
    API_PRODUCT_NEEDS_SYNC,
    API_PRODUCT_TO_BE_SHIPPED,
    API_PRODUCT_OVERSOLD,
    API_PRODUCT_REORDERED,
    API_PRODUCT_INVENTORY_SYNC_SUSPENDED,
  ]
    .map((key) =>
      PRODUCT_BOOLEAN_FILTER_OPTIONS.find((option) => option.value === key),
    )
    .map((option) => ({
      display: option.display,
      reverseDisplay: option.reverseDisplay,
      value: option.value,
      otherNouns: '',
    })),
].map((option) => ({
  ...option,
  entity: option,
  type: STOCKTAKE_PRODUCT_STATUS,
  nouns: [
    ...getNounsFromValue(
      `${option.display} ${option.reverseDisplay} ${option.otherNouns}`,
    ),
  ],
}))

export const STOCKTAKE_LINE_TROOLEAN_FILTERS =
  STOCKTAKE_LINE_TROOLEAN_FILTER_OPTIONS.reduce((prev, {value}) => {
    prev.push(value)
    return prev
  }, [])

export const STOCKTAKE_LINE_TROOLEAN_FILTER_OPTION_TOKENS = tokenizeOptions(
  STOCKTAKE_LINE_TROOLEAN_FILTER_OPTIONS,
)
